module.exports = __webpack_public_path__ + "static/media/ck.e2686b2a.svg";